const ATTACHMENT_FIELDS = `
  fragment AttachmentFields on Attachment {
    id
    type
    url
    dateCreated
    name
    mimeType
    cardId
  }
`
export const CARD_FIELDS = `
  ${ATTACHMENT_FIELDS}
  fragment CardFields on Card {
    id
    description
    creatorId
    created
    updated
    releaseNo
    sortkey
    done
    version
    creator {
      firstname
      lastname
      id
      picture {
        url
        file {
          key
        }
      }
    }
    attachments {
      ...AttachmentFields
    }
    cardTypeId
    cardType {
      id
      title
      domainModelRole
      color {
        red
        green
        blue
      }
    }
    comments {
      id
      author {
        id
        firstname
        lastname
        picture {
          url
          file {
            key
          }
        }
      }
      text
      dateCreated
      dateUpdated
      generatedByAi
    }
    reactions {
      direction
      user {
        id
        firstname
        lastname
        picture {
          url
          file {
            key
          }
        }
      }
    }
    assignee {
      id
      firstname
      lastname
      picture {
        url
        file {
          key
        }
      }
    }
    boundedContext
    schemaId
    tags
  }
`

export const WORKFLOW_FIELDS = `
  ${CARD_FIELDS}
  fragment WorkflowFields on Workflow {
    id
    projectId
    name
    accessLevel
    version
    lanesVersion
    sameAsVersion
    status
    updatedAt
    starred
    aiDescription
    aiAttachments {
      s3Key
      name
      mimeType
      size
    }
    aiVersion
    updateNote {
      userRealName
      action
      target
    }
    lanes {
      id
      name
    }
    eventDefinition {
      title
      description
      color {
        red
        green
        blue
        rgb
      }
    }
    roleDefinition {
      title
      description
      color {
        red
        green
        blue
        rgb
      }
    }
    domainEvents {
      id
      laneId
      groupId
      description
      type
      conditionLabel
      version
      conditionLabels {
        parentId
        name
      }
      parents
      offset
      subprocess {
        id
        name
      }
      color {
        red
        green
        blue
        rgb
      }
      cards {
        ...CardFields
      }
    }
    schemas {
      id
      name
      description
      type
      cardinality
      boundedContext
      entityId
      version
      domainEventIds
      fields {
        name
        description
        exampleData
        cardinality
        relatedEntityId
        type
        tags
        hideInForm
        computed
        dataType
        fields {
          name
          description
          exampleData
          cardinality
          relatedEntityId
          type
          tags
          hideInForm
          computed
          dataType
          fields {
            name
            description
            exampleData
            cardinality
            relatedEntityId
            type
            tags
            hideInForm
            dataType
          }
        }
      }
    }
    boundedContexts {
      id
      name
      templateId
      githubAccountLogin
      githubRepo
      githubBranch
      specFilePath
    }
    groups {
      id
      name
      startSlotX
    }
    releases {
      value
      name
    }
    canAppliconExport
  }
`
